import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// ========== v-viewer 图片预览插件 ===========
import Viewer from 'v-viewer'
import "viewerjs/dist/viewer.css";

// ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 全局样式
import "./assets/css/demo.css";

// axios、工具类
import axios from "axios";
import Base64 from "./utils/base64";
import * as api from "@/apis/index.js";
// import jQuery from "./views/pflip/js/libs/jquery.min.js";


// 挂载全局变量
// Vue.prototype.$jQuery = jQuery;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$api = api
Vue.prototype.$http = axios;
Vue.prototype.$EventBus = new Vue();

Vue.use(ElementUI)
// 注册预览插件
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    toolbar: true,
    rotatable: true,
    movable: true,
    zoomable: true
  }
})

// 全局mixin
Vue.mixin({
  methods: {
    $decodeBase64(encodedString) {
      return Base64.decode(encodedString);
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");